// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront24Filled: FC<Storefront24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M21.025 11.05V19c0 .55-.196 1.02-.587 1.413a1.926 1.926 0 0 1-1.413.587h-14c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 3.025 19v-7.95c-.383-.35-.68-.8-.887-1.35-.209-.55-.213-1.15-.013-1.8l1.05-3.4a2.21 2.21 0 0 1 .713-1.075A1.805 1.805 0 0 1 5.075 3h13.9c.45 0 .842.138 1.175.413.333.275.575.637.725 1.087l1.05 3.4c.2.65.196 1.242-.012 1.775a3.95 3.95 0 0 1-.888 1.375Zm-6.8-1.05c.45 0 .792-.154 1.025-.463.233-.308.325-.654.275-1.037l-.55-3.5h-1.95v3.7c0 .35.117.654.35.913.233.258.517.387.85.387Zm-4.5 0c.383 0 .696-.13.938-.387.241-.259.362-.563.362-.913V5h-1.95l-.55 3.5c-.067.4.02.75.263 1.05.241.3.554.45.937.45Zm-4.45 0c.3 0 .563-.108.788-.325.225-.217.362-.492.412-.825L7.025 5h-1.95l-1 3.35c-.1.333-.046.692.163 1.075.208.383.554.575 1.037.575Zm13.5 0c.483 0 .833-.192 1.05-.575.217-.383.267-.742.15-1.075L18.925 5h-1.9l.55 3.85c.05.333.188.608.413.825a1.1 1.1 0 0 0 .787.325Z" />
        </svg>
    );
};

export default Storefront24Filled;
